// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"QS-z","categoryName":"RS-z","categoryNameSearchHeader":"SS-z","categoryContent":"TS-z","bottomAligned":"US-z","image":"VS-z","imageNoBackground":"WS-z"};